import { render, staticRenderFns } from "./LomList.vue?vue&type=template&id=19fba479"
import script from "./LomList.vue?vue&type=script&lang=js"
export * from "./LomList.vue?vue&type=script&lang=js"
import style0 from "./LomList.vue?vue&type=style&index=0&id=19fba479&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports